interface BotAvatarProps {
  avatarIcon: string
}

const BotAvatar = ({ avatarIcon }: BotAvatarProps) => {
  return (
    <img
      src={avatarIcon}
      alt="bot-avatar-icon"
      className="h-full w-full overflow-hidden rounded-full object-contain"
    />
  )
}

export default BotAvatar
